import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

// material
import {
  Backdrop,
  Box,
  Card,
  Container,
  createTheme,
  Fade,
  Modal,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// components
import Logo from '../../../components/Logo';
import Page from '../../../components/Page';
// import TelaNSerie from './TelaNSerie';
import { useWSContext } from '../../../contexts/WebSocketContext';
import HorarioAtendimento from './HorarioAtendimento';
import NavigationScreens from './NavigationScreens';
import { androidTecnozapVersion } from '../../../controller/android-interface-controller';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: theme.spacing(1, 1, 0, 1),
    backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.7))',
  },
}));
const urlBaseImage = process.env.REACT_APP_BASE_NAME;

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  height: 370,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  background: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.8)), url('${urlBaseImage}/static/ilustration/Conheca-a-Tecnomotor-2.png')`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const ContentStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  maxWidth: '550px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(2, 2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(2),
  position: 'relative',
  top: '-160px',
  boxShadow: theme.shadows[20],
}));

export default function DialogUserCheckout() {
  const { showModalLoginClient } = useWSContext();

  const theme = createTheme();

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={showModalLoginClient}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      sx={{
        display: 'flex',
        width: '100%',
        background: `${theme.palette.background.default}`,
        height: '100vh',
      }}
    >
      <Fade in={showModalLoginClient}>
        <RootStyle title="Login | Cliente">
          <PerfectScrollbar options={{ suppressScrollX: true }}>
            <SectionStyle sx={{ display: { xs: 'flex', md: 'flex', sm: 'flex' } }}>
              <Box
                sx={{
                  px: 2.5,
                  py: 3,
                  display: 'flex',
                  alignItems: 'flex-start',
                }}
              >
                <Logo />
                <Stack direction="column" spacing={0} sx={{ ml: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ color: theme.palette.common.white }}
                  >
                    TECNOZAP
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: theme.palette.common.white,
                      alignSelf: 'end',
                      justifyContent: 'end',
                    }}
                  >
                    {`v${process.env.REACT_APP_VERSION}`}
                    {window.Android && ` | ${androidTecnozapVersion()}`}
                  </Typography>
                </Stack>
              </Box>

              <HorarioAtendimento isWhiteText />
            </SectionStyle>

            <Container maxWidth="sm">
              <ContentStyle>
                <NavigationScreens />
              </ContentStyle>
            </Container>
          </PerfectScrollbar>
        </RootStyle>
      </Fade>
    </Modal>
  );
}
